import axios from "axios";

const API_URL = process.env.NODE_ENV === "production"
  ? ""
  : (process.env.REACT_APP_API_URL || "http://localhost:3001");

const api = axios.create({ baseURL: API_URL });

export const getProducts = (params) => api.get("/api/produtos", { params });
export const getProduct = (id) => api.get(`/api/produtos/${id}`);
export const createProduct = (data) => api.post("/api/produtos", data);
export const updateProduct = (id, data) => api.put(`/api/produtos/${id}`, data);
export const deleteProduct = (id) => api.delete(`/api/produtos/${id}`);
export const uploadImage = (id, file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post(`/api/produtos/${id}/imagem`, form);
};
export const deleteImage = (id) => api.delete(`/api/produtos/${id}/imagem`);
export const reorderSkus = () => api.post("/api/produtos/reordenar-skus");
export const getStats = () => api.get("/api/stats");
export const exportCsvUrl = () => `${API_URL}/api/exportar/csv`;

export default api;
